export default function initFloatingBar() {
    var bar = document.querySelector('.hr-mobile-bar');
    if (!bar) return;

    var lastY = window.scrollY;
    var ticking = false;

    function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
            var currentY = window.scrollY;
            if (currentY > lastY && currentY > 60) {
                bar.classList.add('is-hidden');
            } else {
                bar.classList.remove('is-hidden');
            }
            lastY = currentY;
            ticking = false;
        });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
}
